import { ViewportScroller } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Observable, Subscription } from 'rxjs';
import { UploadFileService } from 'src/app/_services/UploadFile/upload-file.service';
import { AdminsService } from 'src/app/_services/admins/admins.service';
import { InquiresService } from 'src/app/_services/inquires/inquires.service';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

@Component({
  selector: 'app-booking-details',
  templateUrl: './booking-details.component.html',
  styleUrls: ['./booking-details.component.scss']
})
export class BookingDetailsComponent {
  showSide: string = '';
  value: string = '';
  cities: Array<object> = [];
  selectedCity: Object = {};
  available: boolean = true;
  link: Array<boolean> = [true];
  subscriptions: Subscription[] = [];
  listAnchors: any = [
    { id: 'Generalinfo', link: 'General info' },
    { id: 'OtherDetails', link: 'Other Details' },
    { id: 'Documentdetails', link: 'Document details' },
    { id: 'Rentalhistory', link: 'Rental history' },
    { id: 'userinformation', link: 'user information' },
  ];
  titlePage: string = '';
  changeImageUrl: any;
  imageUrl: string = '';
  loadingButton: boolean = false;
  display22: string;

  /////////////////////////mycode///////////////////
 qrImg:string='';
 roomType:any;
 cols:any;
  ngOnInit() {
    // this.GeCheckoutSheet();
    this.cols = [

      { field: 'invoice_Code', header: 'Invoice Code' },
      { field: 'invoice_Duration', header: 'Duration' },
      { field: 'invoice_Amount', header: 'Amount (€)' },
      { field: 'payment_Method', header: 'Payment Method' },
      { field: 'payment_Is_Paid', header: 'Paid' },
      { field: 'invoice_Date', header: 'Invoice Date' },
    ];

 
    

 
     // Retrieve route parameters
     this.requestId = this.route.snapshot.paramMap.get('req_ID');
     this.guestId = this.route.snapshot.paramMap.get('userID');

     if (this.requestId && this.guestId) {
       this.loadBookingDetails(this.requestId, this.guestId);
     }

  
  }
  pendingProblems:any[]=[]
  fixedProblems:any[]=[]


  param: any;
  constructor(
    private route: ActivatedRoute,
    private uploadFile: UploadFileService,
    public _adminservices: AdminsService,
    private viewportScroller: ViewportScroller,
    private _inquiresService: InquiresService,
    private _ActivatedRoute: ActivatedRoute,
    private messageService: MessageService,
    public router: Router
  ) {
    this.param = _ActivatedRoute.snapshot.paramMap.get('id');
  }


  requestId: string | null = null;
  guestId: string | null = null;
  bookingDetails: any;


  loadBookingDetails(requestId: string, guestId: string): void {
    this._adminservices.getBookingDetailsCheckout(requestId, guestId).subscribe(
      (response) => {
        this.CheckoutSheet = response;
        this.roomType=this.CheckoutSheet.bed_Type
        this.roomType = this.roomType[0].toUpperCase() ;
        console.log(this.roomType[0].toUpperCase() )
        // Filter problems into fixed and pending
        this.pendingProblems = this.CheckoutSheet.problems.filter((problem:any) => !problem.is_Fixed);
        this.fixedProblems = this.CheckoutSheet.problems.filter((problem:any) => problem.is_Fixed);
        console.log('Booking Details:',this.CheckoutSheet);
      },
      (error) => {

        console.error(error);
      }
    );
  }


  displayQr:string='none'
  qrCode:string=''
  onOpenQrModal()  {
     this.qrImg = this.CheckoutSheet.qR_Code_Image;
    this.displayQr = 'block';
    this.qrCode = this.CheckoutSheet.qR_Code;

  }

  onCloseQrModal() {
    this.qrImg = '';
    this.displayQr = 'none';

  }



  printDiv(divId: string) {
    const printContents = document.getElementById(divId)?.innerHTML;

console.log(divId,printContents)
    if (printContents) {
      const newWindow = window.open('', '_blank', 'height=600,width=800');
      if (newWindow) {
        newWindow.document.write('<html><head> ');
        newWindow.document.write('  <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css"><style>@media print { body * { visibility: hidden; } #qrToPdf, #qrToPdf * { visibility: visible; } #qrToPdf { position: absolute; left: 0; top: 0 ;bottom:0; width: 100%; height:100% ; page-break-inside: avoid; page-break-before: avoid; page-break-after: avoid; font-size:50px; font-weight:800;  } #qrToPdf img { max-width: 100%; height: 70%; margin-bottom:15px; } }</style>');
        newWindow.document.write('</head><body>');
        newWindow.document.write(`<div id="qrToPdf">${printContents}</div>`);
        newWindow.document.write('</body></html>');
        newWindow.document.close();

        // Wait for the content to load and then print
        newWindow.onload = () => {
          newWindow.focus();
          newWindow.print();
          newWindow.close();
        };
      } else {
        console.error('Failed to open new window');
      }
    } else {
      console.error('Div not found');
    }
  }













  TantsRole: any;
  is_Super: any;

  gotopage() {
    let url: string = 'unlegal';
    this.router.navigateByUrl(url);
  }
  gotopage2() {
    let url: string = 'users';
    this.router.navigateByUrl(url);
  }
  /**
   * initCities
   * @return void
   */
  openmodel(image: any) {
    this.imageSize = image;
    this.display22 = 'block';
  }
  Tenant_details: any = {};
  CheckoutSheet: any = {};
  tenant_photo = '';
  GeCheckoutSheet() {
    this.subscriptions.push(
      this._adminservices.GetCheckoutSheetDetails(this.param,this.guestId).subscribe(
        (res) => {
          this.CheckoutSheet = res;
        },
        (error) => {
          console.error('Error fetching owners:', error);
        }
      )
    );
  }
  User_ID: any;
  FName: any;
  LName: any;
  PassportID: any;
  About: any;
  image: any;

  addItem(value: string) {
    this.showSide = value;
  }

  public onClick(elementId: string): void {
    this.viewportScroller.scrollToAnchor(elementId);
  }

  changeAnchor(index: number): void {
    this.link = this.link.map((el) => (el == true ? false : false));
    this.link[index] = true;
  }
  formData2 = new FormData();
  uploadPic(event: any) {
    this.loadingButton = true;
    if (event != 'delete') {
      const selectedFile = event.target.files[0];
      const formData = new FormData();
      formData.append('fileData', selectedFile, selectedFile.name);
      this.formData2.append('User_Img', selectedFile);
      this.subscriptions.push(
        this.uploadFile.uploadSingleFile(formData).subscribe((img: any) => {
          this.imageUrl = img[0].file_Path;
          this.changeImageUrl.emit(img[0].file_Path);
          this.loadingButton = false;
        })
      );
    } else if (event == 'delete') {
      this.imageUrl = '';
      this.changeImageUrl.emit(this.defaultImageUrl());
      this.loadingButton = false;
    }
  }

  /**
   * defaultImageUrl
   * @returns string
   */
  defaultImageUrl(): string {
    return 'https://t4.ftcdn.net/jpg/05/50/60/49/360_F_550604961_BZT4vo52ysIku2cQ3Zn8sAQg1rXHBKv0.jpg';
  }
  gotodetail(id: any) {
    let url: string = 'invoice/' + id;
    this.router.navigateByUrl(url);
  }
  display1: any = 'none';
  AddnewExpense() {
    this.expense_type = '';
    this.cost_expense = '';
    this.Description_expense = '';
    this.urlimageadd = '';
    this.display1 = 'block';
  }
  onCloseModal1() {
    this.display1 = 'none';
  }
  imageSize: any;
  opencloseModal(photo: any) {
    this.display1 = 'block';
    this.imageSize = photo;
  }

  cost_expense: any = '';
  expense_type: any = '';
  Description_expense: any = '';
  urlimageadd: any = '';
  uploadPic2(event: any) {
    const selectedFile = event.target.files[0];
    this.formData2 = new FormData();
    this.formData2.append('fileData', selectedFile, selectedFile.name);
    this.subscriptions.push(
      this.uploadFile.uploadSingleFile(this.formData2).subscribe((data) => {
        this.urlimageadd = data[0].file_Path;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: `${'Images Upload Successfully'}`,
        });
      })
    );
  }
  selectedFiles?: FileList;
  currentFile?: File;
  progress = 0;
  message = '';
  preview = '';
  imageInfos?: any = [];
  ListFiles: any;
  urls: any = null;
  counter = 0;
  link_create_ads: any = '';
  removeItem() {
    this.ListFiles = null;
    this.urls = null;
  }
  selectFile(event: any): void {
    this.message = '';
    this.preview = '';
    this.progress = 0;
    this.selectedFiles = event.target.files;

    let files = event.target.files;
    this.ListFiles = event.target.files;

    if (files) {
      for (let file of files) {
        this.ListFiles = file;
        let reader = new FileReader();
        reader.onload = (e: any) => {
          this.urls = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    }
  }
  readFile(file: File): Observable<string> {
    return new Observable((obs) => {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        obs.next(reader.result as string);
        obs.complete();
      };
      reader.readAsDataURL(file);
    });
  }
  AddExpense() {
    let data = {
      req_ID: this.param,
      expense_Type: this.expense_type,
      expense_Amount: this.cost_expense,
      expense_Desc: this.Description_expense,
      expense_File: this.urlimageadd,
    };
    this.subscriptions.push(
      this._adminservices.AddExpense(data).subscribe(
        (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res['message'],
          });
          this.display1 = 'none';
          this.expense_type = '';
          this.cost_expense = '';
          this.Description_expense = '';
          this.urlimageadd = '';
          this.GeCheckoutSheet();
        },
        (err: any) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: `${err.error.message[0]}`,
          });
        }
      )
    );
  }
  idUpdat: any = '';
  OpenupdateExpene(data: any) {
    this.expense_type = data.expense_Type;
    this.cost_expense = data.expense_Amount;
    this.Description_expense = data.expense_Desc;
    this.urlimageadd = data.expense_File;
    this.idUpdat = data.expense_ID;
    this.display2 = 'block';
  }
  updateExpene() {
    let data = {
      id: this.idUpdat,
      expense_Type: this.expense_type,
      expense_Amount: this.cost_expense,
      expense_Desc: this.Description_expense,
      expense_File: this.urlimageadd,
    };
    this.subscriptions.push(
      this._adminservices.UpdateExpense(data).subscribe(
        (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res['message'],
          });
          this.display2 = 'none';
          this.expense_type = '';
          this.cost_expense = '';
          this.Description_expense = '';
          this.urlimageadd = '';
          this.GeCheckoutSheet();
        },
        (err: any) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: `${err.error.message[0]}`,
          });
        }
      )
    );
  }
  display2 = 'none';
  onCloseModal2() {
    this.display2 = 'none';
  }
  DeleteExpene(termina: any) {
    this.subscriptions.push(
      this._adminservices.DeleteExpense(termina.expense_ID).subscribe(
        (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res['message'],
          });

          this.expense_type = '';
          this.cost_expense = '';
          this.Description_expense = '';
          this.urlimageadd = '';
          this.GeCheckoutSheet();
        },
        (err: any) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: `${err.error.message[0]}`,
          });
        }
      )
    );
  }
  showEdit: Array<boolean> = [];

  detailperson(event: any, id: any): void {
    this.showEdit = [];
    event.stopPropagation();

    this.showEdit[id] == true
      ? (this.showEdit[id] = false)
      : (this.showEdit[id] = true);
  }
  hidecard() {
    this.showEdit = [];
  }
  display3: any = 'none';
  onCloseModal4() {
    this.display3 = 'none';
  }
  InsertCheckOut() {
    this.subscriptions.push(
      this._adminservices.InsertCheckOut(this.param,this.guestId).subscribe(
        (res) => {
          this.display3 = 'block';
        },
        (error) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: `${error.error.message[0]}`,
          });
          this.display3 = 'none';
        }
      )
    );
  }
  gotoListCheckOut() {
    let url: string = '/checkout-inquire';
    this.router.navigateByUrl(url);
  }





  downloadAsPDF() {
    const element = document.getElementById('qrToPdf'); // ✅ Get div manually

    if (!element) {
      console.error("❌ Error: Cannot find element with ID 'qrToPdf'!");
      return;
    }

    // 🔥 Step 1: Temporarily Show the Hidden Element
    element.style.display = 'block';

    setTimeout(() => {
      // 🔥 Step 2: Capture the div after it becomes visible
      html2canvas(element, { scale: 2 }).then(canvas => {
        const imgData = canvas.toDataURL('image/png'); // Convert to PNG image
        const pdf = new jsPDF('p', 'mm', 'a4'); // Portrait, millimeters, A4 size

        const imgWidth = 190; // A4 width in mm (with some margins)
        const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio

        pdf.addImage(imgData, 'PNG', 10, 10, imgWidth, imgHeight);
        pdf.save('QRCode.pdf'); // Download the PDF file

        // 🔥 Step 3: Hide the div again after capturing
        element.style.display = 'none';

      }).catch(error => {
        console.error("❌ Error generating PDF:", error);
        element.style.display = 'none'; // Ensure the div is hidden even if an error occurs
      });

    }, 500); // Give a small delay for the element to render before capturing
  }



  ngOnDestroy() {
    for (let i = 0; i < this.subscriptions.length; i++)
      this.subscriptions[i].unsubscribe();
  }
}
